import styled from 'styled-components';

export const LoginContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  flex: 1;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`

export const LeftForm = styled.div`
  width: 41vw;
  height: 100vh;

  @media (max-width: 768px) {
    width: 100vw;
    height: 100vh;
  }
`

export const RightCover = styled.div`
  width: 59vw;
  height: 100vh;

  @media (max-width: 768px) {
    width: 100vw;
    height: 30vh;
  }
`